import { render, staticRenderFns } from "./chnToMas.vue?vue&type=template&id=546bf394&scoped=true&"
import script from "./chnToMas.vue?vue&type=script&lang=js&"
export * from "./chnToMas.vue?vue&type=script&lang=js&"
import style0 from "./chnToMas.vue?vue&type=style&index=0&id=546bf394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bf394",
  null
  
)

export default component.exports